export const AuthMessages = {
  bad_credentials: "Пользователь с такими данными не найден.",
  data_error: "Ошибка данных.",
  network_error: 'Нет соединения с сервером.'
}
